module.exports = __webpack_public_path__ + "img/joy-to-the-world-image.49278536.png";